import { KpiOrgScope } from './kpi-org-scope'
import { KpiOrgScopeQuery } from './kpi-org-scope-query'
import { KpiOrgScopeMutation } from './kpi-org-scope-mutation'

export const entities = [KpiOrgScope]
export const resolvers = [KpiOrgScopeQuery, KpiOrgScopeMutation]
